import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'panel.financial.'

@vsingleton()
export class PanelInvoiceRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'invoices.'

  index() {
    return this.ziggyRoute('index')
  }

  download(invoice: number) {
    return this.ziggyRoute('download', invoice)
  }

  payment(invoice: number) {
    return this.ziggyRoute('payment', invoice)
  }

  paymentLink(invoice: number) {
    return this.ziggyRoute('payment_link', invoice)
  }

  exportExcel() {
    return this.ziggyRoute('export')
  }

}
